export default __webpack_public_path__ + "static/media/icon-close.17514505.svg";